'use client';

import React from 'react';
import { Tooltip } from 'src/components';

const NOT_ENOUGH_INFO = 'Not enough info';

interface ReimbursementValueProps {
  amount?: number | null;
  /** Formats a real (non-zero) amount, e.g. v => `$${v.toLocaleString()}` or formatCurrency */
  format: (value: number) => string;
  /** Applied to the placeholder span so callers keep their own cell styling */
  className?: string;
}

const ReimbursementValue = ({
  amount,
  format,
  className,
}: ReimbursementValueProps) => {
  // 0 is never a real calculated value — treat 0 and null/undefined identically as "no data".
  if (amount == null || amount === 0) {
    return (
      <Tooltip
        content={NOT_ENOUGH_INFO}
        position="top"
        slotProps={{
          containerClassName: 'whitespace-normal bg-neutral-900 text-white',
        }}
      >
        <span
          className={`cursor-default ${className ?? ''}`}
          aria-label={NOT_ENOUGH_INFO}
        >
          —
        </span>
      </Tooltip>
    );
  }

  return <>{format(amount)}</>;
};

export default ReimbursementValue;
